<template>
  <div class="color-dropdown">
    <div @click="clearColor" class="clearColor">
      无颜色
    </div>
    <div class="main-wrapper">
      <hue-slider
        ref="hue"
        :color="color"
        vertical
        style="float: right;"
      ></hue-slider>
      <sv-panel ref="sl" :color="color"></sv-panel>
    </div>
    <alpha-slider v-if="showAlpha" ref="alpha" :color="color"></alpha-slider>
    <predefine v-if="predefine" :color="color" :colors="predefine"></predefine>
    <div class="btns">
      <span class="value">
        <el-input
          v-model="customInput"
          @keyup.native.enter="handleConfirm"
          @blur="handleConfirm"
          :validate-event="false"
          size="mini"
        >
        </el-input>
        <span class="color-btn" :style="{ background: customInput }"></span>
      </span>

      <el-button plain size="mini" class="btn" @click="confirmValue">
        确定
      </el-button>
    </div>
  </div>
</template>

<script>
import SvPanel from "./sv-panel";
import HueSlider from "./hue-slider";
import AlphaSlider from "./alpha-slider";
import Predefine from "./predefine";
import Color from "./color";

export default {
  name: "ColorPicker",
  components: {
    HueSlider,
    SvPanel,
    AlphaSlider,
    Predefine
  },

  props: {
    showAlpha: Boolean,
    colorFormat: String,
    predefine: Array
  },

  data() {
    const color = new Color({
      enableAlpha: this.showAlpha,
      format: this.colorFormat
    });
    return {
      color,
      customInput: ""
    };
  },

  computed: {
    currentColor() {
      return this.color.value;
    }
  },

  methods: {
    confirmValue() {
      this.$emit("pick", this.customInput);
    },
    clearColor() {
      this.customInput = "";
    },
    handleConfirm() {
      this.color.fromString(this.customInput);
    }
  },

  mounted() {
    const { sl, hue, alpha } = this.$refs;
    sl && sl.update();
    hue && hue.update();
    alpha && alpha.update();
  },

  watch: {
    currentColor: {
      immediate: true,
      handler(val) {
        this.customInput = val;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.clearColor {
  text-align: center;
  border: 1px solid #ddd;
  line-height: 28px;
  margin: 5px auto;
  cursor: pointer;

  &:hover {
    background: @border-basic;
  }
}

.color-dropdown {
  width: 300px;

  .main-wrapper {
    margin-bottom: 6px;

    &::after {
      content: "";
      display: table;
      clear: both;
    }
  }

  .btns {
    margin-top: 6px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .value {
    float: left;
    line-height: 26px;
    font-size: 12px;
    color: #000000;
    width: 160px;
    display: flex;
    align-items: center;
    .color-btn {
      flex-shrink: 0;
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-left: 10px;
      border-radius: 4px;
    }
  }

  .btn {
    border: 1px solid #dcdcdc;
    color: #333;
    line-height: 24px;
    border-radius: 2px;
    padding: 0 20px;
    cursor: pointer;
    background-color: transparent;
    outline: none;
    font-size: 12px;

    &[disabled] {
      color: #cccccc;
      cursor: not-allowed;
    }
    &:hover {
      color: #409eff;
      border-color: #409eff;
    }
  }

  .link-btn {
    cursor: pointer;
    color: #409eff;
    text-decoration: none;
    padding: 15px;
    font-size: 12px;
    &:hover {
      color: #409eff;
    }
  }
}
</style>
